import { imgs } from '../../assets/imgs'
import { tracking } from '../../utils/tracking'

export const Location = () => {
   return (
      <div className='location'>
         <section>
            <iframe 
               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3168.9659951983217!2d-122.0799839237087!3d37.41427863284353!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb7569249b39b%3A0xea8071641d7ef4f2!2sComputer%20History%20Museum!5e0!3m2!1sen!2sus!4v1708619009454!5m2!1sen!2sus"
               style={{ border: "0", width: "100%", height: "100%" }}
               allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade">
            </iframe>
         </section>
         <section>
            <h1>Location & Directions</h1>
            <p>Computer History Museum</p>
            <div className='icons'>
               <a rel='noreferrer' target="_blank" href="https://maps.app.goo.gl/U4qTgZyMsdcyWhjJ8"
                  onClick={() => tracking(295)}
               >
                  <img src={imgs.icons.googleMaps} alt="google-maps" />
               </a>
               <a
                  rel='noreferrer'
                  target="_blank"
                  href="https://ul.waze.com/ul?preview_venue_id=155910518.1559236253.1092332&navigate=yes&[…]gn=default&utm_source=waze_website&utm_medium=lm_share_location"
                  onClick={() => tracking(296)}
               >
                  <img src={imgs.icons.waze} alt="waze" />
               </a>
            </div>
         </section>
      </div>
   )
}

